
import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Text,
  Input,
  Divider,
  FormControl,
  FormErrorMessage,
  useToast,
  FormLabel,
  Checkbox,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  InputGroup,
  InputLeftAddon,
  FormHelperText,
  Button
} from "@chakra-ui/react";
import PrimaryButton from "../../components/themeComponents/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { syncAnalyticsDB, getSyncAnalyticsDB, getCurrency, getWalletDetails, setWalletCredits, setEnabledSegmentCount, getEnabledSegmentCount } from "../../Services/api";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PowerBiIntegration from "./PowerBiIntegration";
import { useSelector } from "react-redux";
import SyncCustomerDB from "./SyncCustomerDB";
import axiosInstance from "../../Services/axiosInstance";
import { getOrgName,getTokenFromLoacalStorage } from "../../_helpers/helpers";
import axios from "axios";
import SecondaryButton from "../../components/themeComponents/SecondaryButton";

const validationSchema = Yup.object({
  viewNames: Yup.string().required("Name is required"),
});

const OrgFeatures = () => {
  const navigate = useNavigate();
  const token = window.location.pathname.split("/")[3];
  const [wallet, setWallet] = useState({});
  const [currency, setCurrency] = useState("");
  const [orgStatus, setOrgStatus] = useState(true)
  const toast = useToast();
  const [syncData, setSyncData] = useState("");
  const orgInfo = useSelector((state) => (state.auth.selectedOrg))
  const [activeSegmentLimit, setActiveSegmentsLimit] = useState(null)
  const [munshiAmount, setMunshiAmount] = useState("");
  const [munshiReason, setMunshiReason] = useState("");
  const [isMunshiLoading, setIsMunshiLoading] = useState(false);
  const[munshiAvailableCredits,setMunshiAvailableCredits]= useState(0)
  const MUNSI_BASE_URL=process.env.REACT_APP_MUNSHI_URL
  // console.log(orgInfo,"orgIgo")

  const getActiveSegmentLimit = async ()=> {
    let resp = await getEnabledSegmentCount(token)
    console.log(resp?.data)
    setActiveSegmentsLimit(resp?.data?.data?.enabled_segments_count)
  }
const JWT_TOKEN = getTokenFromLoacalStorage()?.jwt;
  const handleNavigation = () => {
    navigate(`/su/allUsers/${token}`);
  };

  useEffect(()=>{
    getActiveSegmentLimit()
  },[])
const fetchCurrectWalletMunsiBalance = async () => {
  try {
    const url = `${MUNSI_BASE_URL}/api/v1/wallets/balance/${token}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${JWT_TOKEN}`,  
      },
    });

    const balance = response?.data?.credits;

    if (balance !== undefined && balance !== null) {
      setMunshiAvailableCredits(balance);
    }

  } catch (e) {
    console.error("Error fetching Munshi wallet balance:", e);
  }
};


  const WalletCreditsForm = ({ currency, wallet, setCredits }) => {
    return (
      <Formik
        initialValues={{ amount: "", reason: "" }}
        onSubmit={(values, { resetForm }) => {
          setCredits(values, true);
          resetForm();
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Flex align="center" justify="space-between" mb={4}>
              <Text fontSize="lg" fontWeight="bold">
                Wallet Credits
                <Text>{currency} {wallet?.balance}</Text>
              </Text>

              <FormLabel p={'1rem'} m={'10px'}>
                Amount (+ / -)
                <Field as={Input} mt={'10px'} type="number" name="amount" required />
              </FormLabel>

               


              <FormLabel p={'1rem'} m={'10px'}>
                Reason (Optional)
                <Field as={Input} mt={'10px'} type="text" name="reason" />
              </FormLabel>

              <PrimaryButton mt={'10px'} label={'Submit'} type="submit" />
            </Flex>
          </Form>
        )}
      </Formik>
    );
  };

  const setEnabledSegmentCountLimit = async ()=>{
    try{

      let resp = await setEnabledSegmentCount(parseInt(activeSegmentLimit) , token)
      console.log(resp) 
      if(!!resp.data.data.success){
        getActiveSegmentLimit() 
        toast({ status: "success", description: "Active segments limit updated successfully", title: "Success" });
      }
    }catch(e){
      toast({ status: "rrror", description: "Something went wrong", title: "Oops!" });
    }
  }
  const toggleApprovedStatus = async () => {
    let url = `/su/account/approval/toggle/${token}/${orgStatus}`
    let response = await axiosInstance.get(url);
    if (!!response) {
      toast({ status: "success", description: "Organization Status updated successfully", title: "Success" });
    }
  }

  const getOrgDetails = async () => {
    let url = "/account/org/details"
    let response = await axiosInstance.get(url);
    if (!!response?.data) {
      setOrgStatus(response?.data?.isApproved)
    }
  }
  const fetchSyncAnalytic = async () => {
    try {
      const response = await getSyncAnalyticsDB(token);

      setSyncData(response.data.data || "");
    } catch (error) {
      console.error("Error while fetching analytics:", error);
    }
  };
  const getCurrencyDetails = async () => {
    try {
      const response = await getCurrency();
      setCurrency(response.data.data.key);
      await getWalletInfo(response.data.data.key);
    } catch (err) {
      console.error("Error fetching currency:", err);

    }
  };

  const getWalletInfo = async () => {
    try {
      if (!currency) return;
      const response = await getWalletDetails(currency);
      setWallet(response?.data);

    } catch (err) {
      console.error("Error fetching wallet details:", err);

    }
  };
  const handleSync = async (values, { setSubmitting }) => {
    // console.log("Form data:", values);
    try {
      await syncAnalyticsDB({ viewNames: values.viewNames }, token);
      toast({
        title: "Success",
        description: "Synced successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      await fetchSyncAnalytic();
    } catch (error) {
      console.error("Sync error:", error);
      toast({
        title: "Error",
        description: "Failed to sync",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSubmitting(false);
    }
  };
  const setCredits = async (values, { setSubmitting }) => {
    // console.log("Form data:", values);
    try {
      let formData = new FormData()
      formData.append("walletAmount", values.amount)
      formData.append("amountReason", values.reason)
      formData.append("walletBalance", wallet.balance)
      formData.append("walletCurrency", currency)
      await setWalletCredits(formData, token);
      toast({
        title: "Success",
        description: "Synced successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      await getCurrencyDetails();
    } catch (error) {

      toast({
        title: "Error",
        description: "Failed to set credits",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      // setSubmitting(false);
    }
  };


  const handleAddMunshiCredits = async () => {
    if (!munshiAmount || Number(munshiAmount) <= 0) {
      toast({ status: "error", title: "Validation", description: "Enter a valid number of credits" });
      return;
    }
    setIsMunshiLoading(true);
    try {
      const payload = {
        org_token: token,
        amount: parseInt(munshiAmount, 10),
      };
      const url = `/su/wallet/munshi/credit/add?orgToken=${token}`;
      const response = await axiosInstance.post(url, payload
);
      if (response && response.data) {
        toast({ status: "success", title: "Success", description: "Munshi credits added successfully" });
        setMunshiAmount("");
        setMunshiReason("");

        await getCurrencyDetails();
      } else {
        throw new Error("Unexpected response");
      }
    } catch (err) {
      console.error("Munshi add credits error:", err);
      toast({ status: "error", title: "Error", description: "Failed to add Munshi credits" });
    } finally {
      setIsMunshiLoading(false);
    }
  };

  useEffect(() => {
    getOrgDetails();
    fetchSyncAnalytic();
    getCurrencyDetails();
    fetchCurrectWalletMunsiBalance()
  }, [token]);

  return (
    <Box p={6} maxW="container.xl" mx="auto">
      <Flex direction="column" gap={6}>
        <Flex direction="column" gap={2}>
          <Text fontSize="2xl" fontWeight="bold">Manage Features for {getOrgName(token)}</Text>
          <Text fontSize="xl" color="gray.600">Super Admin</Text>

        </Flex>
        <Divider my={4} />
        <Flex justifyContent={'space-between'} gap={'10px'} width={'100%'} >
          <FormLabel>

            Organization Status :
            <Checkbox ml={'10px'} onChange={(e) => setOrgStatus(e.target.checked)} isChecked={orgStatus} > {"Active"}  </Checkbox>
          </FormLabel>
          <PrimaryButton label={'Submit'} onClick={toggleApprovedStatus} justifySelf={"end"} />
        </Flex>
        {/* <Divider my={4} /> */}

        {/* <Box>
          <WalletCreditsForm wallet={wallet} currency={currency} setCredits={setCredits} />
        </Box> */}
        
        <Divider my={4} />

        <Box>
          <Flex align="center" justify="space-between" mb={4}>
            <Text fontSize="lg" fontWeight="bold">User Details</Text>
            <PrimaryButton label={"View Details"} onClick={handleNavigation} size="sm" />
          </Flex>
        </Box>

        <Divider my={4} />
      <Box>
  <Flex align="center" justify="space-between" mb={4}>
    <Text fontSize="lg" fontWeight="bold">Wallet(New)</Text>
    <PrimaryButton label="View Details" size="sm" />
  </Flex>
  <Flex align="center" justify="space-between" mb={4}>
    <Text fontSize="lg" fontWeight="bold">Avaliable Credits: {munshiAvailableCredits}</Text>

  </Flex>

  {/* Wallet Add Credit Section (Munshi) */}
  <Box p={5} borderWidth="1px" borderRadius="lg" borderColor="gray.200" bg="white">
    <Text fontSize="xl" fontWeight="semibold" mb={4}>
      Add Credits to Wallet 
    </Text>

    {/* Highlight Note - Very Visible */}
    <Alert status="warning" variant="subtle" mb={5} borderRadius="md">
      <AlertIcon />
      <Box>
        <AlertTitle fontSize="lg">Important Note</AlertTitle>
        <AlertDescription fontWeight="medium">
          This is <Text as="span" color="orange.600" fontWeight="bold">NOT actual currency ({currency})</Text>.
          You are adding <Text as="span" color="blue.600" fontWeight="bold">Credits</Text> to the wallet.
        </AlertDescription>
      </Box>
    </Alert>

    {/* Credit Input Field */}
    <FormControl mb={4}>
      <FormLabel fontWeight="semibold">Number of Credits to Add</FormLabel>
      <InputGroup size="lg">
        <InputLeftAddon bg="blue.50" color="blue.700" fontWeight="bold">
          Credits
        </InputLeftAddon>
        <Input
          type="number"
          placeholder="Enter number of credits (e.g., 500)"
          min="1"
          focusBorderColor="blue.400"
          value={munshiAmount}
          onChange={(e) => setMunshiAmount(e.target.value)}
        />
      </InputGroup>
      <FormHelperText>
        Only whole numbers allowed. These are internal credits, not real money.
      </FormHelperText>
    </FormControl>

    {/* Optional Reason Field */}
    <FormControl mb={4}>
      <FormLabel fontWeight="semibold">Reason (Optional)</FormLabel>
      <Input
        placeholder="Reason for adding credits"
        value={munshiReason}
        onChange={(e) => setMunshiReason(e.target.value)}
      />
    </FormControl>

    {/* Action Buttons */}
    <Flex justify="flex-end" gap={3}>
      <SecondaryButton label={'Cancel'} variant="outline" colorScheme="gray" onClick={() => { setMunshiAmount(""); setMunshiReason(""); }}>
        
      </SecondaryButton>
      <PrimaryButton  label={'Add Credits'}  onClick={handleAddMunshiCredits} isLoading={isMunshiLoading}>
        
      </PrimaryButton>
    </Flex>
  </Box>
</Box>

        <Divider my={4} />


<Box>
  <Flex align="center" justify="space-between" mb={4}>
    <Box>

    <Text fontSize="lg" fontWeight="bold">Active Segments Count</Text>
    <Input type="number" w={"350px"} value={activeSegmentLimit} onChange={(e)=>setActiveSegmentsLimit(e.target.value)} />
    </Box>
    <PrimaryButton label={"Submit"} onClick={()=>setEnabledSegmentCountLimit()} size="sm" />
  </Flex>
</Box>

        <Divider my={4} />
        <Box>
          <Flex direction="column" gap={4}>
            <Flex align="center" justify="space-between" mb={4}>
              <Text fontSize="lg" fontWeight="bold">Sync Analytics DB</Text>
            </Flex>

            <Formik
              initialValues={{ viewNames: syncData }}
              validationSchema={validationSchema}
              onSubmit={handleSync}
              enableReinitialize
            >
              {({ isSubmitting }) => (
                <Form>
                  <FormControl isInvalid={!!(ErrorMessage && ErrorMessage.viewNames)}>
                    <Field name="viewNames">
                      {({ field }) => (
                        <Input
                          placeholder="Enter column names, separated by commas"
                          {...field}
                          size="md"
                        />
                      )}
                    </Field>
                    <ErrorMessage name="viewNames" component={FormErrorMessage} />
                  </FormControl>
                  <Box mt={4}>
                    <PrimaryButton label={"Submit"} type="submit" isLoading={isSubmitting} />
                  </Box>
                </Form>
              )}
            </Formik>
            <PowerBiIntegration />
            <SyncCustomerDB />
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default OrgFeatures;
